import { Card } from "@verde/compose-ui";
import { AlertCircleIcon } from "@verde/icons";
import { type ReactNode, useReducer } from "react";
import {
  type FallbackProps,
  ErrorBoundary as ReactErrorBoundary,
} from "react-error-boundary";

interface FallbackRenderProps extends FallbackProps {
  visible: boolean;
  toggleVisible: () => void;
}

interface ErrorBoundaryProps {
  children: ReactNode;
}

function fallbackRender({
  visible,
  toggleVisible,
  error,
}: FallbackRenderProps) {
  return (
    <Card
      size="sm"
      icon={<AlertCircleIcon onDoubleClick={toggleVisible} />}
      title="Ocorreu um erro inesperado"
      classNames={{
        base: "bg-off-red border border-neutral-light-2",
      }}
    >
      <p className="text-base">
        Nossa equipe já foi notificada e está resolvendo o problema.
        <br />
        Por favor, tente novamente em alguns instantes ou entre em contato com
        seu comercial responsável.
        <br />
        <br />
        <i className="italic">Agradecemos sua paciência!</i>
      </p>

      {visible && <pre>{error.message}</pre>}
    </Card>
  );
}

export function ErrorBoundary({ children }: ErrorBoundaryProps) {
  const [visible, toggleVisible] = useReducer((state) => !state, false);

  return (
    <ReactErrorBoundary
      fallbackRender={(props) => {
        return fallbackRender({
          ...props,
          visible,
          toggleVisible,
        });
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
}
